module.exports = __webpack_public_path__ + "img/18-28-177.25dc6e5a.jpg";